import type { Dictionary } from '../../i18n/dictionary';

const pl = {
  appName: 'Boxer',
  pageTitle: (page: string) => `${page} — Boxer — ITLamb`,
  modular: 'Pudełko modułowe',
  custom: 'Pudełko dowolne',
  intro:
    'Otwarte pudełko do druku 3D. Wymiary są zewnętrzne; plik .3mf otwórz w Bambu Studio, potnij i drukuj.',

  length: 'Długość (mm)',
  width: 'Szerokość (mm)',
  height: 'Wysokość (mm)',
  wall: 'Grubość ścianek i dna',
  wallOption: (mm: string) => `${mm} mm`,
  dimensionRange: (min: number, max: number) =>
    `Podaj całe milimetry od ${min} do ${max}.`,

  preview: 'Podgląd',
  inner: (x: string, y: string, z: string) => `Wnętrze: ${x} × ${y} × ${z} mm`,
  previewLabel: (l: string, w: string, h: string, t: string) =>
    `Pudełko ${l} × ${w} × ${h} mm, ścianki ${t} mm`,
  labelL: 'D',
  labelW: 'S',
  labelH: 'W',
  download: 'Pobierz .3mf',
  fixFields: 'Popraw wymiary, aby zobaczyć podgląd i pobrać plik.',
};

const en: typeof pl = {
  appName: 'Boxer',
  pageTitle: (page) => `${page} — Boxer — ITLamb`,
  modular: 'Modular box',
  custom: 'Custom box',
  intro:
    'An open box for 3D printing. Dimensions are outer; open the .3mf in Bambu Studio, slice and print.',

  length: 'Length (mm)',
  width: 'Width (mm)',
  height: 'Height (mm)',
  wall: 'Wall and floor thickness',
  wallOption: (mm) => `${mm} mm`,
  dimensionRange: (min, max) =>
    `Enter whole millimetres from ${min} to ${max}.`,

  preview: 'Preview',
  inner: (x, y, z) => `Inside: ${x} × ${y} × ${z} mm`,
  previewLabel: (l, w, h, t) => `Box ${l} × ${w} × ${h} mm, ${t} mm walls`,
  labelL: 'L',
  labelW: 'W',
  labelH: 'H',
  download: 'Download .3mf',
  fixFields: 'Fix the dimensions to see the preview and download the file.',
};

export const boxerDict: Dictionary<typeof pl> = { pl, en };
